import React from 'react';
import classNames from 'classnames';
import { SubmissionCommentIndexView } from '../../../types/submission_comments';
import { UserProfileCell } from '../../../../commonv3/components/atoms/users/UserProfileCell';
import { DetailedDateTime } from '@sheinc/design-system';
import './submissionCommentItem.module.scss';

type Props = {
    comment: SubmissionCommentIndexView;
    background: 'blue' | 'white';
};
export const SubmissionCommentItem = ({ comment, background }: Props) => {
    return (
        <div styleName="wrapper">
            <div styleName="header">
                <UserProfileCell user={comment.user} size="l" />
            </div>
            <div
                styleName={classNames('submission-comment-item', background)}
                className="submission-comment-item"
                data-comment-id={comment.id}
            >
                <div className="inner-html" dangerouslySetInnerHTML={{ __html: comment.content }} />
            </div>
            <div styleName="footer">
                <DetailedDateTime date={comment.created_at} />
            </div>
        </div>
    );
};
